import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogIn, Mail, Lock, Loader2 } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';
import { useAuth } from '../context/AuthContext';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_inventory-hub-1442/artifacts/xyf6dc2s_logo-tzanetatos-horizontal.png';

const Login = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const from = location.state?.from || '/admin';

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast({ title: 'Sesión iniciada', description: 'Bienvenido de vuelta.' });
      navigate(from, { replace: true });
    } catch (err) {
      toast({
        title: 'Credenciales inválidas',
        description: err?.response?.data?.detail || 'Verifica tu correo y contraseña.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-[calc(100vh-10rem)] max-w-md items-center px-4 py-12 sm:px-6">
      <div className="w-full overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 bg-gradient-to-r from-[#e9f7e4] to-[#f1faeb] px-8 py-8 text-center">
          <img src={LOGO_URL} alt="Catálogo Tzanetatos" className="mx-auto h-14 w-auto object-contain" />
          <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900">Iniciar Sesión</h1>
          <p className="mt-1 text-sm text-slate-600">Accede al panel de administración</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-5 px-8 py-8">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-slate-700">Correo Electrónico</Label>
            <div className="relative">
              <Mail className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                id="email" type="email" value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="tucorreo@ejemplo.com"
                className="h-11 border-slate-200 pl-10 focus-visible:ring-emerald-500"
                required
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label htmlFor="password" className="text-slate-700">Contraseña</Label>
            <div className="relative">
              <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                id="password" type="password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••"
                className="h-11 border-slate-200 pl-10 focus-visible:ring-emerald-500"
                required
              />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="h-11 w-full gap-2 bg-emerald-700 text-white hover:bg-emerald-800">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogIn className="h-4 w-4" />}
            {loading ? 'Ingresando...' : 'Iniciar Sesión'}
          </Button>
          <p className="text-center text-sm text-slate-500">
            <Link to="/" className="font-medium text-emerald-700 hover:text-emerald-800">Volver al catálogo</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
